import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import PageHeader from '../components/PageHeader';
import { usePageMeta } from '../hooks/usePageMeta';

function NotFound() {
  usePageMeta({ title: 'Page Not Found | EightyThreeLabs' });

  return (
    <Layout>
      <PageHeader
        eyebrow="404"
        title="This page doesn't exist."
        description="The page you're looking for may have moved or never existed. Let's get you back on track."
      >
        <div className="cta-buttons">
          <Link to="/" className="btn-primary">
            Back to Home
          </Link>
          <Link to="/contact" className="btn-secondary">
            Contact Us
          </Link>
        </div>
      </PageHeader>
    </Layout>
  );
}

export default NotFound;
